
// TODO: add production variables
const prod = {}
   
const dev = {
    url: {
     // API_URL: "http://localhost:5000"
     API_URL: "https://plaid-api.k8s.pharmb.io"
    }
   };
   
   
export const config = process.env.NODE_ENV === "development" ? dev : prod;
